// src/components/Footer.tsx
import { Link } from "react-router-dom";
import { Linkedin } from "lucide-react"; //  import LinkedIn icon

const Footer = () => {
  return (
    <footer className="border-t py-8 mt-16 bg-background">
      <div className="container mx-auto px-4 flex flex-col md:flex-row items-center justify-between text-sm text-muted-foreground">
        
        {/* Quick Links */}
        <nav className="flex gap-6 mb-4 md:mb-0">
          <Link to="/" className="hover:text-primary">Home</Link>
          <Link to="/services" className="hover:text-primary">Services</Link>
          <Link to="/about" className="hover:text-primary">About</Link>
          <Link to="/contact" className="hover:text-primary">Contact</Link>
        </nav>

        {/* Legal Links */}
        <nav className="flex gap-6 mb-4 md:mb-0">
          <Link to="/privacy-policy" className="hover:text-primary">Privacy Policy</Link>
        </nav>

        {/* Company Info + Social */}
        <div className="text-center md:text-right flex flex-col md:items-end gap-2">
        {/*  <p>Hanebred 10, Copenhagen, 2720, Denmark</p> */}
          <p>© {new Date().getFullYear()} TechG8. All rights reserved.</p>

          {/* Social Icons */}
          <div className="flex justify-center md:justify-end gap-4 mt-2">
            <a
              href="https://www.linkedin.com/company/TechG8/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-primary transition-colors flex items-center gap-2"
            >
              <Linkedin className="h-5 w-5" />
              <span className="sr-only">LinkedIn</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
